import { useState, useEffect } from 'react';

export default function DesktopFloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section (approximately 600px)
      setIsVisible(window.scrollY > 600);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`hidden md:block fixed bottom-8 right-8 z-50 transition-all duration-300 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
    >
      <a
        href="/book-appointment"
        aria-label="Get a free life insurance quote — no obligation, 24-hour response"
        className="flex items-center gap-3 px-6 py-4 bg-[#D97642] text-white rounded-full shadow-[0_8px_30px_rgba(217,118,66,0.4)] hover:bg-[#C26638] hover:shadow-[0_12px_40px_rgba(217,118,66,0.5)] transition-all cursor-pointer whitespace-nowrap group"
      >
        <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full shrink-0 group-hover:scale-110 transition-transform">
          <i className="ri-file-text-line text-[20px]" aria-hidden="true"></i>
        </div>
        <div className="text-left">
          <div className="text-[15px] font-bold leading-tight">Get a Free Quote</div>
          <div className="text-[12px] text-white/90 leading-tight">No obligation • 24hr response</div>
        </div>
      </a>
    </div>
  );
}